import React, { useEffect, useState } from 'react'
import SeoHelmets from '../SeoOptimazation/SeoHelmets';
import { Link } from 'react-router-dom'
import aboutimg from "../../Image/aboutimg.png"
import { BsJournals } from 'react-icons/bs';
import { FaUserFriends } from 'react-icons/fa';
import axios from 'axios';
import { BASE_URL } from '../../insightConfig/insightConfig';

const UGC_TestSeries = () => {
    const [testSeries, setTestSeries] = useState([]);
    function isValidUrl(string) {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    }

    useEffect(() => {
        axios.get(BASE_URL + '/ugc/user/testseries').then(res => {
            setTestSeries(res.data.data);
        }).catch((error) => {
            console.log(error);
        })

    }, [])
    const dynamicTests = [
        {
            id: 1, Subject: "GENERAL APTITUDE", Image: "https://api.insightdelhi.com/Upload/Course/6376938789465748031%20(2).png", TitleHeading: '/ugc-net/dynamic-testseries/general-aptitude',
        },
        {
            id: 2, Subject: "SUBJECT SPECIFIC", Image: "https://api.insightdelhi.com/Upload/Course/6376938789465748031%20(2).png", TitleHeading: '/ugc-net/dynamic-testseries/subject-specific',
        },
        {
            id: 3, Subject: "COMBINED", Image: "https://api.insightdelhi.com/Upload/Course/6376938789465748031%20(2).png", TitleHeading: '/ugc-net/dynamic-testseries/combined',
        },
    ]
    return (
        <>
            <SeoHelmets 
                title="UGC NET Test Series | Online Mock Tests - Insight IAS" 
                description="Practice with our comprehensive UGC NET Test Series. Get detailed analysis, subject-specific tests, and combined mock exams for UGC NET JRF."
                keywords="UGC NET test series, UGC NET mock test, JRF preparation, online test series for NET"
            />
            {testSeries.length && <div className='AllCardBackground'>
                <h1 className="fw-bold fs-4 text-center py-0 my-0 text-uppercase text-danger">Test Series</h1>
                <div className='AllCard_Box  d-flex justify-content-center'>
                    {testSeries?.map((card, index) => (
                        <div className="card Allcard AllDashboard" key={index}>
                            <Link to={`/neet/testseries/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} */ className='text-decoration-none text-black'>
                                <img src={isValidUrl(card.Image) ? card.Image : aboutimg} className="card-img-top" alt={card.CourseTitle} style={{ height: "140px" }} />
                            </Link>
                            <div className="card-body All-bg">
                                <Link to={`/neet/testseries/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} */ className='text-decoration-none text-black'>
                                    {card.CourseTitle ? <h6 className="fw-bold overflow-hidden" style={{}}>{card.CourseTitle}</h6> : <h6 className="fw-bold overflow-hidden" style={{}}>{card.Title}</h6>}
                                </Link>
                                <hr />
                                <div className="d-flex justify-content-between align-items-center">
                                    <Link to="#" className="card-link list-group-item">
                                        {card.TopicCount ? <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{`${card.TopicCount} LESSONS`}</h6> : <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{`${card.QuizCount || 0} Tests`}</h6>}
                                        {card.SubscriberCount && <h6 className='d-flex align-items-center'><FaUserFriends className='me-1' /> {card.SubscriberCount} SUBSCRIBERS</h6>}
                                    </Link>
                                    <Link to={`/neet/testseries/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} */ className="btn-start list-group-item">START</Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            }
            <div className='AllCardBackground'>
                <h1 className="fw-bold fs-4 text-center py-0 my-0 text-uppercase text-danger">Customised Test Series</h1>
                <div className='AllCard_Box d-flex justify-content-center'>
                    {dynamicTests?.map((card, index) => (
                        <div className="card Allcard AllDashboard" key={index}>
                            <Link to={card?.TitleHeading} state={{ subject: card.Subject }} className='text-decoration-none text-black'>
                                <img src='https://api.insightdelhi.com/Upload/Course/6376938789465748031 (2).png' className="card-img-top" alt={card.Subject} style={{ height: "140px" }} />
                            </Link>
                            <div className="card-body All-bg">
                                <Link to={card?.TitleHeading} state={{ subject: card.Subject }} className='text-decoration-none text-black'>
                                    <p className="fw-bold overflow-hidde fs-5 text-uppercase " >{card.Subject}</p>
                                </Link>
                                <hr />
                                <div className="d-flex justify-content-between align-items-center">
                                    <Link to={card?.TitleHeading} state={{ subject: card.Subject }} className="btn-start list-group-item">CHOOSE PLAN</Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>

    )
}

export default UGC_TestSeries